import _classCallCheck from "/usr/local/dench/git-cf/denchcorp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/local/dench/git-cf/denchcorp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import RestService from '../rest.service';
import LocalStorageService from '@components/collection/components/globals/backend-services/localStorage.service';
var LOGIN_URL = 'api/v1/customerfacing/login';
var CURRENT_CUSTOMER_URL = 'api/v1/customerfacing/currentCustomer';
var LOGOUT_URL = 'api/v1/customerfacing/logout';
var CUSTOMER_AUTH_URL = 'api/v1/customerfacing/customers/smsVerification/authenticate';
var LOGIN_FACEBOOK_URL = 'api/v1/customerfacing/facebook/login';

var LoginService = /*#__PURE__*/function () {
  function LoginService() {
    _classCallCheck(this, LoginService);
  }

  _createClass(LoginService, [{
    key: "currentCustomer",
    value: function currentCustomer() {
      return new Promise(function (resolve, reject) {
        RestService.request(CURRENT_CUSTOMER_URL, {
          method: "GET"
        }, true).then(function (data) {
          if (!data.responsibleGaming.realityCheckInterval) {
            data.responsibleGaming.realityCheckInterval = 10;
          }

          resolve(data);
        }).catch(function (data) {
          reject(data);
        });
      });
    }
  }, {
    key: "customer3DAuthentication",
    value: function customer3DAuthentication(data) {
      return new Promise(function (resolve, reject) {
        RestService.request(CUSTOMER_AUTH_URL, {
          method: "POST",
          body: data
        }, true).then(function (data) {
          resolve(data);
        }).catch(function (data) {
          reject(data);
        });
      });
    }
  }, {
    key: "logout",
    value: function logout() {
      var urlParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return new Promise(function (resolve, reject) {
        RestService.request(LOGOUT_URL + urlParams, {
          method: "POST"
        }, true).then(function (data) {
          resolve(data);
        }).catch(function (data) {
          reject(data);
        });
      });
    }
  }, {
    key: "login",
    value: function login(username, password, isPasted) {
      return new Promise(function (resolve, reject) {
        var data = {
          iovationBlackbox: null,
          password: password,
          rememberme: false,
          username: username
        };

        if (isPasted === true) {
          data['credentialCheck'] = true;
        }

        RestService.request(LOGIN_URL, {
          method: "POST",
          body: data
        }, true).then(function (data) {
          LocalStorageService.set('login-register-ones', 'true');
          resolve(data);
        }).catch(function (data) {
          reject(data);
        });
      });
    }
  }, {
    key: "loginFacebook",
    value: function loginFacebook() {
      return new Promise(function (resolve, reject) {
        RestService.request(LOGIN_FACEBOOK_URL, {
          method: "GET"
        }, true).then(function (data) {
          window.open(data, "_blank");
          resolve(data);
        }).catch(function (data) {
          reject(data);
        });
      });
    }
  }]);

  return LoginService;
}();

export default new LoginService();